import React, { MouseEvent, useState } from 'react';
import { MoreVert } from '@mui/icons-material';
import { ListItemIcon, MenuItem, Popper } from '@mui/material';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { StyledButton, StyledButtonGroup, StyledMenu } from './styles';
import { ExtraActionOption, ExtraActionsMenuProps } from './types';

const ExtraActionsMenu = ({ options, dotsColor, singleItem }: ExtraActionsMenuProps) => {
  const [{ isShowLoadingProgress = false }] = useStore() as unknown as UseStoreValues;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const optionsToMap = options ?? [];

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleSecondaryItemClick = (option: ExtraActionOption) => {
    setAnchorEl(null);
    if (singleItem) {
      option.callback(singleItem);
    } else {
      option.callback();
    }
  };

  return (
    <>
      <StyledButtonGroup color="secondary" aria-label="Page extra actions">
        <StyledButton
          id="extra-actions-dropdown-action"
          onClick={handleClick}
          variant="text"
          disabled={isShowLoadingProgress}
          dotsColor={dotsColor}>
          <MoreVert />
        </StyledButton>
      </StyledButtonGroup>

      <Popper open={open} anchorEl={anchorEl} id={open ? 'transitions-popper' : undefined}>
        <StyledMenu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}>
          {optionsToMap.map((option, optionIndex) => (
            <MenuItem
              key={option.label}
              id={`extra-action-item-${optionIndex + 1}`}
              onClick={() => handleSecondaryItemClick(option)}
              disabled={!option.isActive}>
              {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
              {option.label}
            </MenuItem>
          ))}
        </StyledMenu>
      </Popper>
    </>
  );
};

export default ExtraActionsMenu;
